'use client';

import { useAuth } from '@/lib/auth-context';

export function UserMenu() {
  const { user, role, isLoading, logout } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-20 h-4 bg-zinc-200 dark:bg-zinc-700 rounded animate-pulse" />
      </div>
    );
  }

  if (!user) {
    return (
      <span className="text-xs text-zinc-500 dark:text-zinc-500 px-2 py-1 bg-zinc-100 dark:bg-zinc-800 rounded">
        Viewer
      </span>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-1">
        <span className="text-sm text-zinc-700 dark:text-zinc-300 mr-2">
          {user.name}
        </span>
        <span
          className={`text-xs px-2 py-0.5 rounded ${
            role === 'admin'
              ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
              : role === 'trusted'
              ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
              : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300'
          }`}
        >
          {role}
        </span>
      </div>
      <button
        onClick={logout}
        className="text-xs text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200"
      >
        Logout
      </button>
    </div>
  );
}
